import React from "react";

/**
 * HealthCountBadges - Displays health status counts as color-coded badges
 * @param {Object} healthCounts - Object with healthy, warning, critical, na counts
 * @returns {JSX.Element}
 */
export const HealthCountBadges = ({ healthCounts }) => {
  if (!healthCounts) return null;

  const badgeConfig = [
    {
      key: "healthy",
      label: "H",
      bgColor: "bg-green-100",
      textColor: "text-green-700",
    },
    {
      key: "warning",
      label: "W",
      bgColor: "bg-yellow-100",
      textColor: "text-yellow-700",
    },
    {
      key: "critical",
      label: "C",
      bgColor: "bg-red-100",
      textColor: "text-red-700",
    },
    {
      key: "na",
      label: "NA",
      bgColor: "bg-gray-200",
      textColor: "text-gray-700",
    },
  ];

  return (
    <div className="flex gap-2 text-[9px] font-medium px-2 py-1.5">
      {badgeConfig.map(({ key, label, bgColor, textColor }) =>
        healthCounts[key] > 0 ? (
          <span key={key} className={`px-2 py-0.5 rounded ${bgColor} ${textColor}`}>
            {label}: {healthCounts[key]}
          </span>
        ) : null,
      )}
    </div>
  );
};
